import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i3s_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.j3s_1 = aboutMd;
        this.k3s_1 = connectSuccessMd;
        this.l3s_1 = contributionStartMd;
        this.m3s_1 = boostMd;
        this.n3s_1 = recentInfoMd;
        this.o3s_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.j3s_1 + ', connectSuccessMd=' + this.k3s_1 + ', contributionStartMd=' + this.l3s_1 + ', boostMd=' + this.m3s_1 + ', recentInfoMd=' + this.n3s_1 + ', installSuccessMd=' + this.o3s_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j3s_1);
        result = imul(result, 31) + getStringHashCode(this.k3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.j3s_1 === other.j3s_1))
          return false;
        if (!(this.k3s_1 === other.k3s_1))
          return false;
        if (!(this.l3s_1 === other.l3s_1))
          return false;
        if (!(this.m3s_1 === other.m3s_1))
          return false;
        if (!(this.n3s_1 === other.n3s_1))
          return false;
        if (!(this.o3s_1 === other.o3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstance21oyq66lfgb66,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
